// extracted by mini-css-extract-plugin
export default {"container":"ScrollableContainer_container__DSnmG","vertical":"ScrollableContainer_vertical__3PEmn","horizontal":"ScrollableContainer_horizontal__4VXZP"};